import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import 'react-slidedown/lib/slidedown.css';
import { getInsuranceDocument } from '../../api';
import { Mixpanel } from "../../mixpanel";
import Header from '../header/header';
import './proceedToSign.scss';


const ProceedToSign = () => {
    Mixpanel.track( 'Page view',{page: 'proceed-to-sign'});
    const navigate = useNavigate();
    const {state: locationState} = useLocation();
    const [state, setState] = useState(locationState);
    const [height, setHeight] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const signingLink = state?.signingLink;

    const buttonsRef = useRef<HTMLDivElement>(null)
    const hasFetchedRef = useRef(false);

    useEffect(() => {
        if (!state) {
            navigate(-1);
        }
    }, [state, navigate]);

    useEffect(() => {
        const fetchSigningLink = async () => {
            
            // Only fetch if signingLink is missing and type is insurance, and we haven't fetched yet
            if (!hasFetchedRef.current && !isLoading && locationState && !locationState.signingLink && locationState.type === 'insurance') {
                hasFetchedRef.current = true;
                setIsLoading(true);
                try {
                    const idNumber = window.localStorage.getItem("idNumber");
                    const token = window.localStorage.getItem("token");
                    
                    if (idNumber && token) {
                        const result = await getInsuranceDocument(idNumber, token);
                        setState((prevState: any) => ({
                            ...prevState,
                            signingLink: result.signingLink,
                            numberOfSignatures: result.numberOfSignatures
                        }));
                    }
                } catch (err) {
                    console.error('Error fetching insurance document:', err);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchSigningLink();
    }, [locationState, isLoading]);

    const redirectToSign = () => {
        if (!signingLink) {
            return;
        }
        Mixpanel.track( 'Sign documents clicked');
        window.location.href = signingLink;
    }
    const handleButtonClick = () => {
        if (!state) {
            return;
        }

        if (isLoading || !signingLink) {
            setButtonLoading(true);
            return;
        }

        redirectToSign();
    };

    useEffect(() => {
        if (buttonLoading && !isLoading) {
            if (signingLink) {
                redirectToSign();
            }
            setButtonLoading(false);
        }
    }, [buttonLoading, isLoading, signingLink]);

    useEffect(()=>{
        window.addEventListener('resize', ()=>{
            if (buttonsRef?.current?.clientHeight) {
                setHeight(window.innerHeight - buttonsRef.current.clientHeight);
            }
        });
    },[])

    useEffect(() => {
        if (buttonsRef?.current?.clientHeight) {
            setHeight(window.innerHeight - buttonsRef.current.clientHeight);
        }
    })

    return (
        <>
            <div className="proceedToSign">
                <div className="wrapper"style={{height: height+'px'}}>
                    <Header />
                    <div className="content">

                        <div className="hi-user">{state.clientName},</div>
                        <div className="texts">
                            <div className="text1">
                                אנא {state.gender === 'female'?'חתמי':'חתום'} על המסמכים מטה כדי שנוכל לבצע עבורך את החיסכון.
                            </div>
                            {state.type === 'pension' ? (
                                <div className="text2">
                                    לאחר אישורך, המערכת שלנו תבצע בקרה 24/7 לאיתור הנחות פוטנציאליות נוספות. כמו כן, אנו נמונה כסוכן הפנסיוני שלך, ונעניק לך שירות שוטף מול המעסיק הנוכחי ובכל שאלה או פעולה אותה {state.gender === 'female'?'תרצי':'תרצה'} לבצע.
                                </div>
                            ) : (
                                <div className="text2">
                                    לאחר אישורך, המערכת שלנו תבצע בקרה 24/7 לאיתור הנחות פוטנציאליות נוספות.
                                </div>
                            )}

                            {state.numberOfSignatures > 1?<div className="text2">
                                {state.gender === 'female'?'שימי':'שים'} לב כי יידרשו ממך {state.numberOfSignatures}{" "}
                                חתימות בסה״כ כדי שנוכל לבצע את הפעולה. ככה הם אוהבים בתעשייה הפיננסית. 😊
                            </div>:<div className="text2">
                                {state.gender === 'female'?'שימי':'שים'} לב כי תדרש ממך חתימה אחת בלבד כדי שנוכל לבצע את הפעולה. ככה הם אוהבים בתעשייה הפיננסית. 😊
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="buttons" ref={buttonsRef}>
                    <button 
                        className="approve-button" 
                        onClick={handleButtonClick}
                        disabled={buttonLoading}
                    >
                        {buttonLoading ? (
                            <span className="button-loading">
                                טוען...
                                <span className="loading-spinner" />
                            </span>
                        ) : (
                            'לחתימה על הטפסים'
                        )}
                    </button>
                </div>
            </div>
        </>
    );
}

export default ProceedToSign;
